export default __webpack_public_path__ + "static/media/bathroom1-after-1440w.0651de4f.webp";